<div class="block-home">
  <h1>{{ 'groups.groupsFinish' | translate }}</h1>
  <lms-list
    [listId]="listId"
    [serviceProvider]="groupsService"
    (collectionUpdated)="setCollection($event)"
    [options]="listOptions"
  >
    <div class="table">
      <div class="table-heading">
        <lms-list-header [listId]="listId" class="table-item" field="name" label="nouns.name"></lms-list-header>
        <lms-list-header [listId]="listId" class="table-item" field="clientName" label="nouns.client"></lms-list-header>
        <lms-list-header
          [listId]="listId"
          class="table-item"
          field="startDate"
          label="nouns.startDate"
        ></lms-list-header>
        <lms-list-header [listId]="listId" class="table-item" field="endDate" label="nouns.endDate"></lms-list-header>
      </div>
      <div *ngFor="let group of groups" class="table-row">
        <div class="table-item cursor-pointer">
          <a [routerLink]="['/groups', group.id]" title="{{ 'actions.edit' | translate }} {{ group.name }}">{{
            group.name
          }}</a>
        </div>
        <div class="table-item cursor-pointer">
          <a
            [routerLink]="['/clients', group.clientId]"
            title="{{ 'actions.edit' | translate }} {{ group.clientName }}"
            >{{ group.clientName }}</a
          >
        </div>
        <div class="table-item">{{ group.startDate | lmsDate : group.timezone }}</div>
        <div class="table-item">{{ group.endDate | lmsDate : group.timezone }}</div>
      </div>
    </div>
  </lms-list>
</div>
